import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useProfile } from "@/hooks/useProfile";

interface RequireTermsProps {
  children: React.ReactNode;
}

/**
 * Gate routes behind Terms acceptance. Reads from the centralized
 * `useProfile` cache so navigating between protected pages doesn't
 * re-hit the profiles table.
 *
 * After a successful accept, invalidate ["profile", userId] to refresh.
 */
const RequireTerms = ({ children }: RequireTermsProps) => {
  const { user, loading } = useAuth();
  const { profile, isLoading } = useProfile();

  if (loading || (user && isLoading)) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <p className="text-muted-foreground">Se încarcă...</p>
      </div>
    );
  }

  if (!user) return <Navigate to="/auth" replace />;
  if (!profile?.terms_accepted_at) return <Navigate to="/accept-terms" replace />;

  return <>{children}</>;
};

export default RequireTerms;
